module.exports = __webpack_public_path__ + "img/whyx.299872b9.jpg";